























































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbAlert, mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardImage, mdbInput, mdbCardBody, mdbCardTitle, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbView, mdbMask, mdbCardFooter } from '@folky-tools/mdbvue';
import { usersService, associationFrontPagesService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { AssociationFrontPage } from '@/models/associations/association-front-page';
import { AssociationFrontPageImages } from '@/models/associations/association-front-page-images';
import { AssociationFrontPageClaims } from '@/models/associations/association-front-page-claims';
import { OtherLinks } from '@/models/common/other-links';
import { Link } from '@/models/common/link';
import { ContactDetails } from '@/models/common/contact-details';

@Component({
    components: {
        mdbAlert,
        mdbBtn,
        mdbCard,
        mdbCardImage,
        mdbCardBody,
        mdbCardTitle,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbView,
        mdbMask,
        mdbInput,
        mdbDropdown,
        mdbDropdownToggle,
        mdbDropdownMenu,
        mdbCardFooter,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        CropitImage: () => import('@/components/shared/CropitImage.vue'),
        Wysiwyg: () => import('@/components/shared/Wysiwyg.vue'),
        EditSocialMediaLinks: () => import('@/components/shared/EditSocialMediaLinks.vue'),
        EditOtherLinks: () => import('@/components/shared/EditOtherLinks.vue'),
        EditSlug: () => import('@/components/shared/EditSlug.vue'),
        EditContactDetails: () => import('@/components/shared/EditContactDetails.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class AssociationFrontPageView extends Vue {
    private frontPage: AssociationFrontPage = new AssociationFrontPage();
    private frontPageImages: AssociationFrontPageImages = new AssociationFrontPageImages();
    private frontPageClaims: AssociationFrontPageClaims = new AssociationFrontPageClaims();
    private frontPageDescription?: string = '';
    private socialMediaLinks: Link[] = [];
    private slug?: string = '';
    private otherLinks: Link[] = [];
    private contactDetails: ContactDetails = new ContactDetails();

    private showEditFrontPageLogo: boolean = false;
    private showEditFrontPageImages: boolean = false;
    private showEditFrontPageTitles: boolean = false;
    private showEditFrontPageDescription: boolean = false;
    private showEditFrontPageContactDetails: boolean = false;
    private showEditFrontPageOtherLinks: boolean = false;
    private showEditFrontPageSlug: boolean = false;
    private showEditFrontPageSocialMediaLinks: boolean = false;

    private savingFrontPageLogo: boolean = false;
    private savingFrontPageImages: boolean = false;
    private savingFrontPageTitles: boolean = false;
    private savingFrontPageDescription: boolean = false;
    private savingFrontPageSocialMediaLinks: boolean = false;
    private savingFrontPageOtherLinks: boolean = false;
    private savingFrontPageSlug: boolean = false;
    private savingFrontPageContactDetails: boolean = false;
    private discartingFrontPageChanges: boolean = false;
    private applyingFrontPageChanges: boolean = false;
    private publishingFrontPage: boolean = false;

    get imagesWereChanged(): boolean {
        return (
            this.frontPage.imageWasChanged(this.frontPageImages.first!.type!, this.frontPageImages.first!.url!) ||
            this.frontPage.imageWasChanged(this.frontPageImages.second!.type!, this.frontPageImages.second!.url!) ||
            this.frontPage.imageWasChanged(this.frontPageImages.third!.type!, this.frontPageImages.third!.url!)
        );
    }

    get pageModButtons(): boolean {
        return !this.frontPage.hasAtLeastOneFrontPagePublished || this.frontPage.isTemporary;
    }

    get publicationIsAvailable(): boolean {
        return !this.frontPage.hasAtLeastOneFrontPagePublished && this.slug !== undefined && this.slug !== null && this.slug !== '';
    }

    // #region GENERIC

    private async created(): Promise<void> {
        await this.init();
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.associations.associationFrontPageView.title', this.$route.query.associationName);

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Associations,
                scope: UserActionScopeType.Frontpage,
                entityId: +this.$route.params.id
            })
        );
    }

    private async init(): Promise<void> {
        const frontPage = await associationFrontPagesService.getFrontPage(+this.$route.params.id);

        if (frontPage) {
            this.frontPage = frontPage;
        }

        this.frontPageImages = new AssociationFrontPageImages(frontPage.images);
        this.frontPageClaims = new AssociationFrontPageClaims({
            claim: this.frontPage.claim,
            subclaim: this.frontPage.subclaim,
            metaClaim: this.frontPage.metaClaim
        });
        this.frontPageDescription = this.frontPage.description;

        this.socialMediaLinks = [];
        this.frontPage.initSocialMediaLinks();
        this.frontPage.socialMediaLinks.forEach(link => {
            this.socialMediaLinks.push(link.clone());
        });

        this.slug = this.frontPage.slug;
        this.otherLinks = [];
        this.frontPage.otherLinks.forEach(link => {
            this.otherLinks.push(link.clone());
        });

        this.contactDetails = new ContactDetails();
        if (this.frontPage.contactDetails) {
            this.contactDetails = this.frontPage.contactDetails.clone();
        }
    }

    private async discardChanges(): Promise<void> {
        this.discartingFrontPageChanges = true;
        try {
            if (await associationFrontPagesService.discardChanges(+this.$route.params.id)) {
                await this.init();
                notificationsService.showToastSuccessNotification('common.notifications.changesDiscarded');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.Frontpage,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.discartingFrontPageChanges = false;
        }
    }

    private async applyChanges(): Promise<void> {
        this.applyingFrontPageChanges = true;
        try {
            if (await associationFrontPagesService.applyChanges(+this.$route.params.id)) {
                await this.init();
                notificationsService.showToastSuccessNotification('common.notifications.changesApplied');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.Frontpage,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.applyingFrontPageChanges = false;
        }
    }

    private async publish(): Promise<void> {
        this.publishingFrontPage = true;
        try {
            if (await associationFrontPagesService.publish(+this.$route.params.id)) {
                await this.init();
                notificationsService.showToastSuccessNotification('common.notifications.changesApplied');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.Publication,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.publishingFrontPage = false;
        }
    }

    // #endregion GENERIC

    // #region EDIT TITLES

    private editFrontPageTitles(): void {
        this.showEditFrontPageTitles = true;
    }

    private async saveFrontPageTitles(): Promise<void> {
        this.savingFrontPageTitles = true;
        try {
            if (this.frontPage.claim !== this.frontPageClaims.claim || this.frontPage.subclaim !== this.frontPageClaims.subclaim || this.frontPage.metaClaim !== this.frontPageClaims.metaClaim) {
                if (await associationFrontPagesService.updateClaims(+this.$route.params.id, this.frontPageClaims)) {
                    this.frontPage.claim = this.frontPageClaims.claim;
                    this.frontPage.subclaim = this.frontPageClaims.subclaim;
                    this.frontPage.metaClaim = this.frontPage.metaClaim;
                    this.frontPage.isTemporary = true;
                    this.closeFrontPageTitlesEdition();

                    notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.titlesUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Associations,
                            scope: UserActionScopeType.Titles,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }

                notificationsService.showToastErrorNotification();
                return;
            }
            this.closeFrontPageTitlesEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageTitles = false;
        }
    }

    private closeFrontPageTitlesEdition(): void {
        this.showEditFrontPageTitles = false;
    }

    // #endregion EDIT TITLES

    // #region EDIT LOGO

    private editFrontPageLogo(): void {
        this.showEditFrontPageLogo = true;
    }

    private async saveFrontPageLogo(): Promise<void> {
        this.savingFrontPageLogo = true;
        try {
            if (this.frontPage.imageWasChanged(this.frontPageImages.logoImage!.type!, this.frontPageImages.logoImage!.url!)) {
                const logoFile: File = (this.$refs.editFrontPageLogo as any).getFinalImageFile();

                if (logoFile) {
                    const result = await associationFrontPagesService.updateImage(+this.$route.params.id, this.frontPageImages.logoImage!.type!, logoFile);

                    if (result) {
                        this.frontPage.setImageUrl(this.frontPageImages.logoImage!.type!, result);
                        this.frontPage.isTemporary = true;
                        this.closeFrontPageLogoEdition();

                        notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.logoUpdated');

                        await usersService.logUserAction(
                            new UserActionLogInfo({
                                type: UserActionType.HasChanged,
                                entity: UserActionEntityType.Associations,
                                scope: UserActionScopeType.Logistics,
                                entityId: +this.$route.params.id
                            })
                        );

                        return;
                    }
                }

                notificationsService.showToastErrorNotification();
                return;
            }
            this.closeFrontPageLogoEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageLogo = false;
        }
    }

    private closeFrontPageLogoEdition(): void {
        this.frontPageImages = new AssociationFrontPageImages(this.frontPage.images);
        this.showEditFrontPageLogo = false;
    }

    // #endregion EDIT LOGO

    // #region EDIT IMAGES

    private editFrontPageImages(): void {
        this.showEditFrontPageImages = true;
    }

    private async saveFrontPageImages(): Promise<void> {
        this.savingFrontPageImages = true;
        try {
            if (this.imagesWereChanged) {
                const uploadingFirstImageResult = this.frontPage.imageWasChanged(this.frontPageImages.first!.type!, this.frontPageImages.first!.url!)
                    ? await associationFrontPagesService.updateImage(+this.$route.params.id, this.frontPageImages.first!.type!, (this.$refs.editFrontPageFirstImage as any).getFinalImageFile())
                    : this.frontPageImages.first!.url!;

                const uploadingSecondImageResult = this.frontPage.imageWasChanged(this.frontPageImages.second!.type!, this.frontPageImages.second!.url!)
                    ? await associationFrontPagesService.updateImage(+this.$route.params.id, this.frontPageImages.second!.type!, (this.$refs.editFrontPageSecondImage as any).getFinalImageFile())
                    : this.frontPageImages.second!.url!;

                const uploadingThirdImageResult = this.frontPage.imageWasChanged(this.frontPageImages.third!.type!, this.frontPageImages.third!.url!)
                    ? await associationFrontPagesService.updateImage(+this.$route.params.id, this.frontPageImages.third!.type!, (this.$refs.editFrontPageThirdImage as any).getFinalImageFile())
                    : this.frontPageImages.third!.url!;

                if ([uploadingFirstImageResult, uploadingSecondImageResult, uploadingThirdImageResult].every(result => result !== undefined && result !== null)) {
                    this.frontPage.setImageUrl(this.frontPageImages.first!.type!, uploadingFirstImageResult);
                    this.frontPage.setImageUrl(this.frontPageImages.second!.type!, uploadingSecondImageResult);
                    this.frontPage.setImageUrl(this.frontPageImages.third!.type!, uploadingThirdImageResult);
                    this.frontPage.isTemporary = true;
                    this.closeFrontPageImagesEdition();

                    notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.imagesUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Associations,
                            scope: UserActionScopeType.Images,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }

                notificationsService.showToastErrorNotification();
                return;
            }
            this.closeFrontPageImagesEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageImages = false;
        }
    }

    private closeFrontPageImagesEdition(): void {
        this.frontPageImages = new AssociationFrontPageImages(this.frontPage.images);
        this.showEditFrontPageImages = false;
    }

    // #endregion EDIT IMAGES

    // #region EDIT DESCRIPTION

    private editFrontPageDescription(): void {
        this.showEditFrontPageDescription = true;
    }

    private onUpdateFrontPageDescription(htmlContent: string): void {
        this.frontPageDescription = htmlContent;
    }

    private async saveFrontPageDescription(): Promise<void> {
        this.savingFrontPageDescription = true;
        try {
            if (this.frontPage.description !== this.frontPageDescription) {
                if (await associationFrontPagesService.updateDescription(+this.$route.params.id, this.frontPageDescription!)) {
                    this.frontPage.description = this.frontPageDescription;
                    this.frontPage.isTemporary = true;
                    this.closeFrontPageDescriptionEdition();

                    notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.descriptionUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Associations,
                            scope: UserActionScopeType.Description,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }

                notificationsService.showToastErrorNotification();
                return;
            }
            this.closeFrontPageDescriptionEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageDescription = false;
        }
    }

    private closeFrontPageDescriptionEdition(): void {
        this.frontPageDescription = this.frontPage.description;
        this.showEditFrontPageDescription = false;
    }

    // #endregion EDIT DESCRIPTION

    // #region EDIT CONTACT DETAILS

    private editFrontPageContactDetails(): void {
        this.showEditFrontPageContactDetails = true;
    }

    private async saveFrontPageContactDetails(): Promise<void> {
        this.savingFrontPageContactDetails = true;
        try {
            if (await associationFrontPagesService.updateContactDetails(+this.$route.params.id, this.contactDetails)) {
                this.frontPage.contactDetails = this.contactDetails.clone();
                this.frontPage.isTemporary = true;
                this.closeFrontPageContactDetails();

                notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.contactDetailsUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.ContactData,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageContactDetails = false;
        }
    }

    private closeFrontPageContactDetails(): void {
        this.contactDetails = this.frontPage.contactDetails.clone();
        this.showEditFrontPageContactDetails = false;
    }

    // #endregion EDIT CONTACT DETAILS

    // #region EDIT OTHER LINKS

    private editFrontPageOtherLinks(): void {
        this.showEditFrontPageOtherLinks = true;
    }

    private async saveFrontPageOtherLinks(): Promise<void> {
        this.showEditFrontPageOtherLinks = true;
        const editOtherLinksElement: any = this.$refs.editOtherLinks;

        try {
            const otherLinks = new OtherLinks();
            otherLinks.otherLinks = editOtherLinksElement.links;

            if (await associationFrontPagesService.updatOtherLinks(+this.$route.params.id, otherLinks)) {
                this.frontPage.otherLinks = [];
                otherLinks.otherLinks.forEach(link => {
                    if (link.url && link.url !== '') {
                        this.frontPage.otherLinks.push(link.clone());
                    }
                });
                this.frontPage.isTemporary = true;
                this.closeFrontPageOtherLinksEdition();

                notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.additionalLinksUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.OtherLinks,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageOtherLinks = false;
        }
    }

    private closeFrontPageOtherLinksEdition(): void {
        this.otherLinks = [];
        this.frontPage.otherLinks.forEach(link => {
            this.otherLinks.push(link.clone());
        });
        this.showEditFrontPageOtherLinks = false;
    }

    // #endregion EDIT OTHER LINKS

    // #region EDIT SOCIAL MEDIA LINKS

    private editFrontPageSocialMediaLinks(): void {
        this.showEditFrontPageSocialMediaLinks = true;
    }

    private async saveFrontPageSocialMediaLinks(): Promise<void> {
        this.savingFrontPageSocialMediaLinks = true;

        if ((this.$refs.editSocialMediaLinks as any).hasErrors()) {
            this.savingFrontPageSocialMediaLinks = false;
            return;
        }

        try {
            if (await associationFrontPagesService.updateSocialMediaLinks(+this.$route.params.id, this.socialMediaLinks)) {
                this.frontPage.socialMediaLinks = [];
                this.socialMediaLinks.forEach(link => {
                    this.frontPage.socialMediaLinks.push(link.clone());
                });
                this.frontPage.isTemporary = true;
                this.closeFrontPageSocialMediaLinksEdition();

                notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.socialLinksUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.SocialMediaLinks,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageSocialMediaLinks = false;
        }
    }

    private closeFrontPageSocialMediaLinksEdition(): void {
        this.socialMediaLinks = [];
        this.frontPage.socialMediaLinks.forEach(link => {
            this.socialMediaLinks.push(link.clone());
        });
        this.showEditFrontPageSocialMediaLinks = false;
    }

    // #endregion EDIT SOCIAL MEDIA LINKS

    // #region EDIT SLUG

    private editFrontPageSlug(): void {
        this.showEditFrontPageSlug = true;
    }

    private async saveFrontPageSlug(): Promise<void> {
        this.showEditFrontPageSlug = true;
        const editSlugElement: any = this.$refs.editSlug;

        if (editSlugElement.hasErrors()) {
            this.savingFrontPageSlug = false;
            return;
        }

        try {
            if (!(await associationFrontPagesService.checkIfSlugExists(+this.$route.params.id, this.slug!))) {
                if (await associationFrontPagesService.updateSlug(+this.$route.params.id, this.slug!)) {
                    this.frontPage.slug = this.slug;
                    this.frontPage.isTemporary = true;
                    this.closeFrontPageSlugEdition();

                    notificationsService.showToastSuccessNotification('views.associations.associationFrontPageView.notifications.slugUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Associations,
                            scope: UserActionScopeType.Slug,
                            entityId: +this.$route.params.id
                        })
                    );

                    return;
                }
                notificationsService.showToastErrorNotification();
            } else {
                notificationsService.showToastErrorNotification('views.associations.associationFrontPageView.notifications.slugExists');
                return;
            }
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageSlug = false;
        }
    }

    private closeFrontPageSlugEdition(): void {
        this.slug = this.frontPage.slug;
        this.showEditFrontPageSlug = false;
    }

    // #endregion EDIT SLUG
}
